module.exports = __webpack_public_path__ + "img/bg_color.ba13369e.png";